module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('heading', {
    attrs: {
      "text": _vm.review.album,
      "level": 2,
      "font": "oswald",
      "color": "red",
      "variant": "uppercase"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [(_vm.review.id_groupe) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'band',
        params: {
          id: _vm.review.id_groupe
        }
      }
    }
  }, [(_vm.review.cover) ? _c('figure', [_c('img', {
    attrs: {
      "src": _vm.review.cover,
      "alt": _vm.review.album
    }
  }), _vm._v(" "), _c('figcaption', {
    staticClass: "band"
  }, [_vm._v(_vm._s(_vm.review.band))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.review.date) ? _c('div', {
    staticClass: "credits"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('reviews.credits')) + " " + _vm._s(_vm.review.author))]), _c('br'), _vm._v("\n      " + _vm._s(_vm.$d(new Date(_vm.review.date), 'short')) + "\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.review.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "video",
    domProps: {
      "innerHTML": _vm._s(_vm.review.video)
    }
  }), _vm._v(" "), (_vm.$loading) ? _c('loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e54c4f3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/router-views/webzine/Review.vue
// module id = 261
// module chunks = 0